import { isValid, waitSeconds } from "../utilitiesmodule";

/**********************************REPOSITORY*****************************************************************************************************/
export async function saveRepository(repository) {
	var newRepository = isValid(repository.id) ?
		await this.$api.editRepository(repository) :
		await this.$api.createRepository(repository);


	if (!isValid(newRepository)) {
		return false;
	}

	if (!isValid(repository.id)) {
		this.$session.addRepository(newRepository);
	} else {
		this.$session.editRepository(newRepository);
	}

	// Do il tempo all'utente di visualizzare il messaggio di buona riuscita dell'operazione
	await waitSeconds(2);
	this.$root.$emit('CLOSEREPOSITORYDIALOG');
	this.$root.$emit("REFRESHREPOSITORIES", newRepository);
	return true;

}

export async function duplicateRepository(repository) {
	var newRepository = repository
	newRepository.id = null;

	var self = this;

	var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
	var dialogTitle = this.$t("Duplicate Repository \"{0}\"", { 0: repository.name });
	var dialogContent = this.$t("Insert a name for the repository");//this.$t('Are you sure to duplicate repository \"{0}\"? ', { 0: repository.name });
	var placeholder = this.$t("Insert a name");
	var initialValue = repository.name + " (DUPLICATED)";
	this.$root.$on(dialogID, async newName => {
		var closeDialog = true;
		try {
			if (newName == null || newName == "") {
				return;
			}

			newRepository.name = newName
			var ok = await this.saveRepository(newRepository);

			if (ok) {
				return;
			}

			//Tengo aperta la dialog per consentire all'utente di riprovare
			closeDialog = false;

		} finally {
			if (closeDialog) {
				self.$root.$off(dialogID);
				self.$router.removeHash();
				if ($("#newText") && $("#newText").parent() && $("#newText").parent().parent()) {
					Metro.dialog.close($("#newText").parent().parent());
				}                        // prototype implementato in main.js
				//location.reload();
			}
		}
	});


	//Avvio la richiesta che mi risponderà con un $emit
	this.$root.openInsertTextDialog(dialogID, dialogTitle, dialogContent, placeholder, initialValue, 50);
}

export async function deleteRepository(repository) {
	var self = this;

	var dialogID = Math.floor(100000 + Math.random() * 900000).toString();
	var dialogTitle = this.$t("Delete Repository \"{0}\"", { 0: repository.name });
	var dialogContent = this.$t('Are you sure to delete repository \"{0}\"?', { 0: repository.name });

	this.$root.$on(dialogID, async ok => {
		var closeDialog = true;
		try {
			if (!ok) {
				return;
			}

			ok = await self.$api.deleteRepository(repository.id, repository.name);

			if (!ok) {
				closeDialog = false;
				return;
			}

			// Do il tempo all'utente di visualizzare il messaggio di buona riuscita dell'operazione
			await waitSeconds(2);
			self.$session.deleteRepository(repository.id);
			this.$root.$emit("REFRESHREPOSITORIES");

		} finally {
			if (closeDialog) {
				self.$root.$off(dialogID);
				self.$router.removeHash(); // prototype implementato in main.js
			}
		}
	});

	//Avvio la richiesta che mi risponderà con un $emit
	this.$root.openYesNoDialog(dialogID, dialogTitle, dialogContent)

}
